import React, { useEffect, useState } from 'react';
import styles from './submit-button.module.css';

type SubmitButtonProps = {
  value: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
  buttonStyle?: object;
  variant?: string;
};

function SubmitButton(props: SubmitButtonProps) {
  const { value, disabled, onClick, buttonStyle, variant } = props;
  let buttonClass = `${styles.submit} ${styles[variant]} title-2sb`;

  const [forceDisable, setForceDisable] = useState(false);
  const handleOnClick = (
    evt: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setForceDisable(true);

    if (onClick) onClick(evt);
  };
  useEffect(() => {
    let disableTimeout: NodeJS.Timeout;
    if (forceDisable) {
      disableTimeout = setTimeout(() => setForceDisable(false), 2000);
    }

    return () => clearTimeout(disableTimeout);
  }, [forceDisable]);

  if (disabled) {
    switch (variant) {
      case 'primary':
        buttonClass += ` ${styles.primaryDisabled}`;
        break;
      case 'secondary':
        buttonClass += ` ${styles.secondaryDisabled}`;
        break;
      default:
        break;
    }
  }

  return (
    <button
      className={buttonClass}
      style={buttonStyle}
      disabled={forceDisable ? forceDisable : disabled}
      onClick={handleOnClick}
    >
      {value}
    </button>
  );
}

export default SubmitButton;
